import { render, staticRenderFns } from "./tagCell.vue?vue&type=template&id=5df2c154&scoped=true"
import script from "./tagCell.vue?vue&type=script&lang=js"
export * from "./tagCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df2c154",
  null
  
)

export default component.exports